//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';

import ProductSuggestionOverlay from '@uia/intelligent-product-tagging/ProductSuggestionOverlay';
import makeAngularReactControllerWithScope from '@react-bridge/angular-react-widget-with-scope';
import { IScope } from 'angular';

// Since `getAngularInjector()` can't grab service instances from the UIA application, we need
// to grab them via dependency injection & pass them as props to the redux component.
// This ensures that this component will get the correct instances of these services
// no matter what context it's used in.
// TODO: Clean this up once UIA has been migrated to the main app (DEV-50548)
angular.module('curalate').component('newProductSuggestionOverlay', {
  bindings: {
    suggestionBoxClicked: '&',
    universalItemId: '@',
  },
  controller: [
    'AssistedProductTaggingService',
    'ProductTaggingService',
    '$rootScope',
    'UniversalImageActionsService',
    function (
      AssistedProductTaggingService,
      ProductTaggingService,
      $rootScope,
      UniversalImageActionsService,
    ) {
      this.AssistedProductTaggingService = AssistedProductTaggingService;
      this.ProductTaggingService = ProductTaggingService;
      this.$rootScope = $rootScope;
      this.UniversalImageActionsService = UniversalImageActionsService;
    },
  ],
  template: `<product-suggestion-overlay-impl
      assisted-product-tagging-service="$ctrl.AssistedProductTaggingService"
      product-tagging-service="$ctrl.ProductTaggingService"
      root-scope="$ctrl.$rootScope"
      suggestion-box-clicked="$ctrl.suggestionBoxClicked({boxId, coordinates, event})"
      universal-item-id="{{ $ctrl.universalItemId }}"
      uia-service="$ctrl.UniversalImageActionsService"
    ></product-suggestion-overlay-impl>`,
});

angular.module('curalate').component('productSuggestionOverlayImpl', {
  bindings: {
    assistedProductTaggingService: '<',
    productTaggingService: '<',
    rootScope: '<',
    suggestionBoxClicked: '&',
    uiaService: '<',
    universalItemId: '@',
  },
  controller: makeAngularReactControllerWithScope(
    (
      scope: {
        $ctrl: React.ComponentProps<typeof ProductSuggestionOverlay>;
      } & IScope,
    ) => {
      return (
        <ProductSuggestionOverlay
          assistedProductTaggingService={
            scope.$ctrl.assistedProductTaggingService
          }
          productTaggingService={scope.$ctrl.productTaggingService}
          rootScope={scope.$ctrl.rootScope}
          suggestionBoxClicked={scope.$ctrl.suggestionBoxClicked}
          uiaService={scope.$ctrl.uiaService}
          universalItemId={scope.$ctrl.universalItemId}
        />
      );
    },
  ),
});
